export default __webpack_public_path__ + "static/media/defaultCard.3b774d21.png";